import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getSortedCollection } from "sprint-common-web";

import { useAdminAirlineApi } from "../../../airline/common/api/useAdminAirlineApi";
import { mapToSystemPlatformListingItem, SystemPlatformListingItem } from "../SystemPlatformListingItem";
import { SystemPlatformListingFilters } from "../useSystemPlatformListingFilters";
import { SystemPlatformListingContext } from "./SystemPlatformListingContext";

export const SystemPlatformsListingProvider: React.FC = ({ children }) => {
    const { getSystemPlatformsList } = useAdminAirlineApi();

    const { airlineId } = useParams<{ airlineId: string }>();

    const [systemPlatforms, setSystemPlatforms] = useState<SystemPlatformListingItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [airlineName, setAirlineName] = useState<string>("");
    const [buzzId, setBuzzId] = useState<string>();
    const [shreqId, setShreqId] = useState<string>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        getSystemPlatformsList({ airlineId }).then((response) => {
            const items = response.items.map((item) => mapToSystemPlatformListingItem(item));

            setAirlineName(response.airlineName);
            setBuzzId(response.buzzId);
            setShreqId(response.shreqId);
            setSystemPlatforms(items);
            setIsLoading(false);
        });
    }, []);

    const load = (filters: SystemPlatformListingFilters): void => {
        const sortedItems = getSortedCollection(systemPlatforms, filters.sortBy, filters.sortOrder);

        setTotalItems(sortedItems.length);
        setSystemPlatforms(sortedItems);
    };

    const createSystemPlatform = (systemPlatform: SystemPlatformListingItem) => {
        setSystemPlatforms((prevState) => [...prevState, { ...systemPlatform, isModified: true }]);
    };

    const deleteSystemPlatform = (systemId: string) => {
        setSystemPlatforms(systemPlatforms.filter((item) => item.systemId !== systemId));
    };

    return (
        <SystemPlatformListingContext.Provider
            value={{
                systemPlatforms,
                airlineName,
                buzzId,
                shreqId,
                isLoading,
                totalItems,
                load,
                createSystemPlatform,
                deleteSystemPlatform
            }}
        >
            {children}
        </SystemPlatformListingContext.Provider>
    );
};
